import { gsap } from 'gsap';

export default class Tabs {
    constructor() {
        this.init();
    }

    init() {
        this.setupTabs();
        this.activateFirstTab();
    }

    setupTabs() {
        const buttons = document.querySelectorAll('.tab-button');
        const contents = document.querySelectorAll('.tab-content');

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const zone = button.getAttribute('data-zone');

                buttons.forEach(btn => btn.classList.remove('active'));
                contents.forEach(content => {
                    content.classList.remove('active');
                    this.resetMarkers(content);
                });

                button.classList.add('active');
                const activeContent = document.querySelector(`.tab-content[data-zone="${zone}"]`);
                activeContent.classList.add('active');

                this.showPrimaryContentOnly(activeContent);

                this.addPostItemClickEvents(activeContent);
                this.addMarkerClickEvents(activeContent);

                this.animateMarkers(activeContent);
            });
        });
    }

    activateFirstTab() {
        const firstButton = document.querySelector('.tab-button');
        const firstContent = document.querySelector('.tab-content');

        if (firstButton && firstContent) {
            firstButton.classList.add('active');
            firstContent.classList.add('active');
            this.showPrimaryContentOnly(firstContent);
            this.addPostItemClickEvents(firstContent);
            this.addMarkerClickEvents(firstContent);

            this.animateMarkers(firstContent);
        }
    }

    showPrimaryContentOnly(content) {
        const items = content.querySelectorAll('.post-item');
        items.forEach(item => {
            if (item.classList.contains('primary')) {
                item.style.display = 'block';
                item.classList.add('active');
                const postId = item.getAttribute('data-post-id');
                const activeMarker = content.querySelector(`.marker[data-post-id="${postId}"]`);
                if (activeMarker) {
                    activeMarker.classList.add('active');
                }
            } else {
                item.style.display = 'none';
            }
        });
    }

    resetMarkers(content) {
        const markers = content.querySelectorAll('.marker');
        markers.forEach(marker => {
            gsap.set(marker, { opacity: 0, display: 'none' });
        });
    }

    animateMarkers(content) {
        const markers = Array.from(content.querySelectorAll('.marker'));
        const activeMarker = markers.find(marker => marker.classList.contains('active'));

        if (activeMarker) {
            gsap.set(activeMarker, { display: 'block', opacity: 0 });
            gsap.to(activeMarker, { display: 'block', opacity: 1, duration: 0.5, onComplete: () => {
                    markers.filter(marker => !marker.classList.contains('active')).forEach((marker, index) => {
                        gsap.set(marker, { display: 'block', opacity: 0 });
                        gsap.to(marker, { display: 'block', opacity: 1, duration: 0.5, delay: index * 0.2 });
                    });
                }});
        } else {
            markers.forEach((marker, index) => {
                gsap.set(marker, { display: 'block', opacity: 0 });
                gsap.to(marker, { display: 'block', opacity: 1, duration: 0.5, delay: index * 0.2 });
            });
        }
    }

    addPostItemClickEvents(content) {
        const items = content.querySelectorAll('.post-item');
        const markers = content.querySelectorAll('.marker');

        items.forEach(item => {
            item.addEventListener('click', () => {
                items.forEach(itm => itm.classList.remove('active'));
                markers.forEach(mrk => mrk.classList.remove('active'));

                const postId = item.getAttribute('data-post-id');
                item.classList.add('active');
                const activeMarker = content.querySelector(`.marker[data-post-id="${postId}"]`);
                if (activeMarker) {
                    activeMarker.classList.add('active');
                }

                items.forEach(itm => itm.style.display = 'none');
                item.style.display = 'block';
            });
        });
    }

    addMarkerClickEvents(content) {
        const items = content.querySelectorAll('.post-item');
        const markers = content.querySelectorAll('.marker');

        markers.forEach(marker => {
            marker.addEventListener('click', () => {
                items.forEach(itm => itm.classList.remove('active'));
                markers.forEach(mrk => mrk.classList.remove('active'));

                const postId = marker.getAttribute('data-post-id');
                marker.classList.add('active');
                const activeItem = content.querySelector(`.post-item[data-post-id="${postId}"]`);
                if (activeItem) {
                    activeItem.classList.add('active');
                    activeItem.style.display = 'block';
                }

                items.forEach(itm => {
                    if (itm !== activeItem) {
                        itm.style.display = 'none';
                    }
                });
            });
        });
    }
}
